import { css } from "lit";

export const styles = css`
  .config-content {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 16px;
  }

  .section {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .audio-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    background: var(--sds-color-background-default-secondary);
    border-radius: var(--sds-border-radius-03);
  }

  .audio-label {
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-02) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-default);
  }

  .permission-status {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    border-radius: var(--sds-border-radius-03);
    font: var(--sds-typography-weight-regular) var(--sds-typography-scale-01) var(--sds-typography-family-body);
  }

  .permission-status.checking {
    background: var(--sds-color-background-default-secondary);
    color: var(--sds-color-text-default-secondary);
  }

  .permission-status.granted {
    background: var(--sds-color-background-success-subtle);
    color: var(--sds-color-text-success-default);
  }

  .permission-status.denied {
    background: var(--sds-color-background-danger-subtle);
    color: var(--sds-color-text-danger-default);
  }

  .permission-status.prompt {
    background: var(--sds-color-background-warning-subtle);
    color: var(--sds-color-text-warning-default);
  }

  .modal-actions {
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    padding-top: 8px;
  }

  @media (max-width: 768px) {
    .config-content {
      overflow-y: auto;
      max-height: calc(100dvh - 120px);
      padding-bottom: 12px;
    }

    .modal-actions {
      flex-direction: column-reverse;
    }
  }
`;
